import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async () => {
        APP_COMPONENTS.serviceForms.add();
    }
};
